export default __webpack_public_path__ + "static/media/rgp_pvh_nca_north_kazakh.4e2e8154.png";